import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import OTPInput from 'react-otp-input';

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import config from '../helper/config';
import { isEmpty } from "../helper/common";
import { userLogin } from "../Axios/user.axios";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import Subscriber from "../Layout/subscribe";
import { useSelector } from "react-redux";
import CommonFunction from "../helper/commonfucnctioncomponet";


const initform = {
    UserName: "",
    EmailId: "",
    // Mobile: "",
    Password: '',
    ConfirmPassword: '',
    TermsandConditions: false,
};

const initname = {
    UserName: "User Name",
    EmailId: "Email-Id",
    // Mobile: "",
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    TermsandConditions: "The Term and Policy must be accepted."
}


export default function Register() {


    const navigate = useNavigate()
    const userdata = useSelector((state) => state?.LoginReducer?.User)
    const commonfuncfile = CommonFunction()


    const EMAILregex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const [forms, setForms] = useState({});
    const [focusoutfield, SetFocusOutField] = useState({});
    const [focusedfield, SetFocusedField] = useState([]);

    const [formdata, SetFormdata] = useState(initform);
    const [displayname, SetDisplayName] = useState(initname);
    const [Error, SetError] = useState({});
    const [Page, SetPage] = useState("register");
    const [counter, setCounter] = useState(120);
    const [Otp, SetOTP] = useState('');
    const [Timer, SetTimer] = useState({
        Minutes: 0,
        Seconds: 0,
    })
    const [DisableStatus, SetDisableStatus] = useState({})
    const [CurrentTab, SetCurrentTab] = useState(1);

    const [passwordType, setPasswordType] = useState("password");
    const [passwordType1, setPasswordType1] = useState("password");
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const togglePassword1 = () => {
        if (passwordType1 === "password") {
            setPasswordType1("text")
            return;
        }
        setPasswordType1("password")
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        UserLoginCheck();
    }, []);

    const OnChange = (e) => {
        const { id, value } = e.target;
        // SetError({})
        SetFormdata({ ...formdata, ...{ [id]: value } });
    }

    const Validate = () => {
        let error = {};
        (Object.keys(formdata)).map((val) => {
            if (isEmpty(formdata[val])) {
                error[val] = (val == "TermsandConditions" ? displayname[val] : "Enter " + displayname[val]);
            }
            else {
                if (val == 'EmailId') {
                    if (!config.EMAIL.test(formdata[val])) {
                        error[val] = "Enter Valid EmailId.";
                    }
                }
                else if (val == 'Password') {
                    if (!config.PASSWORD.test(formdata[val])) {
                        error[val] = "Password must contain alphanumeric, must contain 8 to 15 letters.";
                    }
                }
                else if (val == 'ConfirmPassword' && formdata?.ConfirmPassword != formdata?.Password) {
                    error[val] = "Password and Confirm Password Must be Same.";
                }
            }
        })
        return error
    }

    const Register = async () => {
        let error = Validate();
        if (isEmpty(error)) {
            let senddata = Page == 'register' ? formdata : { ...(Page == 'registerverify' ? { Otp: Otp } : {}), ...{ EmailId: formdata.EmailId } };
            senddata.Type = Page;
            var Resp = await userLogin(senddata);
            console.log('userLogin_resp', Resp)
            if (Resp?.success == 'success') {
                if (Page == 'register') {
                    SetPage('registerverify')
                }
                if (Page == 'resend') {
                    setCounter(120)
                    SetPage('registerverify');
                    SetOTP('');
                }
                if (Page == 'registerverify') {
                    navigate('/login');
                }
                toast.success(Resp.msg, 1000)
            }
            else {
                toast.error(Resp.msg, 1000);
            }
        }
        else {
            SetError(error);
            toast("Fill the Correct datas", { type: 'error' })
        }
    }

    useEffect(() => {
        if (Page == 'registerverify') {
            if (counter == 0) {
                SetPage('resend');
            }
            const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
            const seconds = String(counter % 60).padStart(2, 0);
            const minutes = String(Math.floor(counter / 60)).padStart(2, 0);
            SetTimer({
                Minutes: minutes,
                Seconds: seconds
            })
            return () =>
                clearInterval(timer);
        }
    }, [counter, Page]);

    const OnBlurFn = (e) => {
        const { id, value } = e.target;
        let error = Validate();
        Object.keys(error).map((currkey) => {
            if (currkey == id || focusedfield.includes(currkey)) {
            }
            else {
                delete error[currkey];
            }
        })
        if (focusedfield?.includes(id)) {
        }
        else {
            SetFocusedField([
                ...focusedfield,
                ...[id],
            ])
        }
        SetError(error);
    }

    const UserLoginCheck = async () => {
        let resp = await commonfuncfile.UserCheck();
        if(resp?.status){
            navigate('/profile');
        }
    }

    return (

        <>

            <div className="register">

                <Header />

                <section className="section">
                    <div className="container font-md">
                        <section className="section box-page-register">
                            <div className="container">
                                <div className="row">

                                    <div className="col-lg-5">
                                        <div className="box-steps-small">

                                            <div className={Page == "register" ? "item-number hover-up active" : "item-number hover-up"} >
                                                <div className="num-ele">1</div>
                                                <div className="info-num"><h5 className="color-brand-1 mb-15">Register</h5><p className="font-md color-grey-500">All you need is your name, email and a strong password, Or use your social media accounts.</p></div>
                                            </div>

                                            <div className={Page == "registerverify" ? "item-number hover-up active" : "item-number hover-up"}>
                                                <div className="num-ele">2</div>
                                                <div className="info-num"><h5 className="color-brand-1 mb-15">Activate</h5><p className="font-md color-grey-500">Use the code sent to your email to activate your account.</p></div>
                                            </div>

                                        </div>
                                    </div>
                                    {
                                        Page == 'register' &&
                                        <div className="col-lg-7">
                                            <div className="box-register">
                                                <h2 className="color-brand-1 mb-15">Create an account</h2>
                                                <p className="font-md color-grey-500 mb-4">Create an account today and start using our platform</p>

                                                <form className="row" action="" novalidate="novalidate">

                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group mb-4">
                                                            <input className={focusedfield?.includes('UserName') ? (Error?.UserName ? "form-control icon-name is-invalid" : "form-control icon-name is-valid") : "form-control icon-name"} type="text" name="name" placeholder="Your Name" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} id='UserName' value={formdata?.UserName || ''} />
                                                            {Error?.UserName && (
                                                                <span className="error-msg">{Error.UserName}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group mb-4">
                                                            <input className={focusedfield?.includes('EmailId') ? (Error?.EmailId ? "form-control icon-email is-invalid" : "form-control icon-email is-valid") : "form-control icon-email"} type="email" name="EmailId" placeholder="Your Email" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} id='EmailId' value={formdata?.EmailId || ''} />
                                                            {Error?.EmailId && (
                                                                <span className="error-msg">{Error.EmailId}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group position-relative mb-4">
                                                            <input className={focusedfield?.includes('Password') ? (Error?.Password ? "form-control icon-password input-green-bd is-invalid" : "form-control icon-password input-green-bd is-valid") : "form-control icon-password input-green-bd"} type={passwordType} name="Password" autocomplete="new-password" placeholder="Enter Password" aria-required="true" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} id='Password' value={formdata?.Password || ''} />
                                                            <div onClick={togglePassword}>
                                                                {passwordType == "text" ? <FaRegEye className="eyepassword" /> :
                                                                    <FaRegEyeSlash className="eyepassword" />}</div>

                                                            {Error?.Password && (
                                                                <span className="error-msg">{Error.Password}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group position-relative mb-4">
                                                            <input className={focusedfield?.includes('ConfirmPassword') ? (Error?.ConfirmPassword ? "form-control icon-password input-green-bd is-invalid" : "form-control icon-password input-green-bd is-valid") : "form-control icon-password input-green-bd"} type={passwordType1} name="password_confirmation" placeholder="Confirm Password" aria-required="true" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} id='ConfirmPassword' value={formdata?.ConfirmPassword || ''} />
                                                            <div onClick={togglePassword1}>
                                                                {passwordType1 === "text" ? <FaRegEye className="eyepassword" /> :
                                                                    <FaRegEyeSlash className="eyepassword" />}</div>
                                                            {Error?.ConfirmPassword && (
                                                                <span className="error-msg">{Error.ConfirmPassword}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 mt-15">
                                                        <div className="form-group mb-4">
                                                            <label><span className="text-small">Your personal data will be used to support your experience throughout this website, to manage access to your account, and for other purposes described in our privacy policy.</span></label>
                                                        </div>
                                                        <div className="form-group mb-4">
                                                            <label className="cb-container">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="TermsandConditions"
                                                                    onChange={(e) => {
                                                                        SetFormdata({
                                                                            ...formdata,
                                                                            ...{ TermsandConditions: formdata?.TermsandConditions ? false : true }
                                                                        });
                                                                        SetError({ ...Error, ...{ TermsandConditions: '' } });
                                                                    }}
                                                                    checked={formdata?.TermsandConditions} />
                                                                <span className="text-small ms-2">I agree to terms &amp; Policy.</span>
                                                            </label>
                                                            {Error?.TermsandConditions && (
                                                                <span className="error-msg">{Error.TermsandConditions}</span>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="row align-items-center mt-30 ">
                                                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                                                            <div className="form-group">
                                                                <button className="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => Register()}>Sign up now</button>
                                                            </div>
                                                        </div>

                                                        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6">
                                                            <span className="d-inline-block align-middle font-sm color-grey-500">Already have an account?</span>

                                                            <Link className="d-inline-block align-middle color-success ms-1" to="/login"> Sign In</Link>
                                                        </div>
                                                    </div>

                                                </form>


                                            </div>

                                        </div>
                                    }

                                    {
                                        (Page == 'registerverify' || Page == 'resend') &&
                                        <div className="col-lg-7">
                                            <div className="box-register">
                                                <h2 className="color-brand-1 mb-15">Email Verification</h2>
                                                <p className="font-md color-grey-500 mb-4">Enter OTP Send to {formdata?.EmailId}</p>
                                                <form className="row" action="" novalidate="novalidate">

                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group alllogin mb-4">
                                                            <OTPInput
                                                                value={Otp}
                                                                onChange={SetOTP}
                                                                numInputs={4}
                                                                renderSeparator={<span>-</span>}
                                                                renderInput={(props) => <input {...props} />}
                                                            />
                                                            {Error?.Otp && <span>{Error.Otp}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div className="form-group mb-4">
                                                            <p className="pr-4"> Otp will expires in <b> {Timer.Minutes}:{Timer.Seconds}</b></p>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-center mt-30 ">
                                                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6">
                                                            <div className="form-group">
                                                                <button type="button" className="btn btn-brand-lg btn-full font-md-bold" onClick={() => Register()} disabled={DisableStatus?.[Page]}>
                                                                    {Page == 'resend' ? "Resend-OTP" : "Verify OTP"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </section>
                    </div>
                </section>

                <Subscriber />
                {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                    <form action="" className="newsletter-form" novalidate="novalidate">

                                        <input type="email" name="email" placeholder="Enter your email..." />
                                        <button className="btn btn-submit-newsletter" type="submit">
                                            <FaArrowRight />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}


                <Footer />

            </div>

        </>
    );
}
